export const textLang: any = {
    eu: {
        icon1: 'Microwave Oven',
        icon2: 'Toaster',
        icon3: 'Vacuum Cleaner',
        icon4: 'Coffee Maker',
        icon5: 'Blender',
        icon6: 'Juicer',
        icon7: 'Wi‑Fi Router',
        icon8: 'Phone Charger',
        icon9: 'Laptop',
    },
    uk: {
        icon1: 'Microwave Oven',
        icon2: 'Toaster',
        icon3: 'Vacuum Cleaner',
        icon4: 'Coffee Maker',
        icon5: 'Blender',
        icon6: 'Juicer',
        icon7: 'Wi‑Fi Router',
        icon8: 'Phone Charger',
        icon9: 'Laptop',
    },
    de: {
        icon1: 'Mikrowelle',
        icon2: 'Toaster',
        icon3: 'Staubsauger',
        icon4: 'Kaffeemaschine',
        icon5: 'Mixer',
        icon6: 'Entsafter',
        icon7: 'WLAN Router',
        icon8: 'Handy-Ladegerät',
        icon9: 'Laptop',
    },
    fr: {
        icon1: 'Four à micro-ondes',
        icon2: 'Grille pain',
        icon3: 'Aspirateur',
        icon4: 'Cafetière',
        icon5: 'Mixeur',
        icon6: 'Extracteur de jus',
        icon7: 'Routeur Wi-Fi',
        icon8: 'Chargeur de téléphone',
        icon9: 'Ordinateur portable',
    },
    it: {
        icon1: 'Forno a microonde',
        icon2: 'Tostapane',
        icon3: 'Aspirapolvere',
        icon4: 'Macchina per il caffè',
        icon5: 'Frullatore',
        icon6: 'Spremiagrumi',
        icon7: 'Router Wi-Fi',
        icon8: 'Caricabatterie del telefono',
        icon9: 'Computer portatile',
    },
    es: {
        icon1: 'Horno microondas',
        icon2: 'Tostadora',
        icon3: 'Aspiradora',
        icon4: 'Cafetera',
        icon5: 'Licuadora',
        icon6: 'Exprimidor',
        icon7: 'Router Wi-Fi',
        icon8: 'Cargador de teléfono',
        icon9: 'Ordenador portátil',
    },
};
